import React from 'react';

export const checkRTL = (str) => {
  if (str) {
    const count = (str.match(/[\u04c7-\u0591\u05D0-\u05EA\u05F0-\u05F4\u0600-\u06FF]/g) || []).length;
    return count / str.length > 0.3;
  }
  return false;
};

export const RtlWrapper = ({ children, propsNames = [] }) => {
  // Check if the sentence contains more than 30% word in RTL language
  // Because we already count white space in the string
  // 30% is high enough to consider that the sentence is arabic/hebrew etc.
  let result;
  let flag = false;
  let rtlBool = false;

  function rtlRecursive(component) {
    React.Children.map(component, child => {
      if (child?.props) {
        if (child?.props?.children) {
          rtlRecursive(child?.props?.children);
        }
        propsNames.forEach(propsName => {
          let check = false;
          if (propsName === 'dangerouslySetInnerHTML') {
            const innerhtml = child?.props[propsName];
            /* eslint no-underscore-dangle: 0 */
            check = checkRTL(innerhtml?.__html);
          } else {
            check = checkRTL(child.props[propsName]);
          }
          if (check) {
            rtlBool = true;
          }
        });

        if (rtlBool) {
          flag = true;
        }
      }
    });
  }

  rtlRecursive(children);

  if (flag) {
    const props = { className: `rtl ${children?.props?.className}`, children: children?.props?.children };
    result = React.cloneElement(children, props);
  } else {
    result = children;
  }
  return result;
};
